import { useParams } from "react-router-dom";

import { ChemicalsTable } from "../../ChemicalsTable";

export function FacilityChemical() {
  const { facilityId = "" } = useParams<{ facilityId: string }>();

  return <ChemicalsTable facilityId={facilityId} />;
}
